import { useState } from 'react'

import { Button } from 'core-components/library/button'
import { Input } from 'core-components/library/inputs'
import { Loader } from 'core-components/library/loader'
import { userApi } from 'src/core/classes/services/api/UserApi'

import styles from './GuestLogin.module.scss'

interface IGuestLogin {
  onSubmit: (result: boolean) => void
}

export const GuestLogin = (props: IGuestLogin) => {
  const [nick, setNick] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)

  return (
    <div className={styles.root}>
      <div className={styles.separator}>
        <div className={styles.separator_draw} />
        <div className={styles.separator_text}>or</div>
        <div className={styles.separator_draw} />
      </div>
      <div className={styles.description}>Create Nickname to continue as a guest:</div>
      <div className={styles.container}>
        <Input
          classes={{ root: styles.input }}
          id={'TEST_GuestLoginInput'}
          label={'Enter Nickname'}
          value={nick}
          onChange={(value) => setNick(value)}
          margin={'sm'}
        />
        <Button
          id={'TEST_GuestLoginButton'}
          className={styles.button}
          disabled={loading}
          onClick={async () => {
            if (nick) {
              setLoading(true)
              const result = await userApi.signInGuest(nick)
              props.onSubmit(result)
              setLoading(false)
            }
          }}
        >
          {loading ? <Loader dimension={{ width: 20, height: 20 }} /> : 'Sign in as guest'}
        </Button>
      </div>
    </div>
  )
}
